import React from 'react';
// styles
import styled from 'styled-components';

const CartPackagesIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Cart Packages"
    className={className}
  >
    <path
      d="M5.1542 15.875C5.96316 15.875 6.61895 15.2192 6.61895 14.4102C6.61895 13.6013 5.96316 12.9455 5.1542 12.9455C4.34524 12.9455 3.68945 13.6013 3.68945 14.4102C3.68945 15.2192 4.34524 15.875 5.1542 15.875Z"
      fill="#FCC475"
    />
    <path
      d="M15.4103 15.875C16.2193 15.875 16.8751 15.2192 16.8751 14.4102C16.8751 13.6013 16.2193 12.9455 15.4103 12.9455C14.6013 12.9455 13.9456 13.6013 13.9456 14.4102C13.9456 15.2192 14.6013 15.875 15.4103 15.875Z"
      fill="#FCC475"
    />
    <path
      d="M5.15405 5.86375C5.15405 5.32417 5.59147 4.88675 6.13105 4.88675H9.3048C9.84438 4.88675 10.2818 5.32417 10.2818 5.86375V9.0375C10.2818 9.57708 9.84438 10.0145 9.3048 10.0145H6.13105C5.59147 10.0145 5.15405 9.57708 5.15405 9.0375V5.86375Z"
      fill="#FCC475"
    />
    <path
      d="M11.3806 5.86375C11.3806 5.32417 11.818 4.88675 12.3576 4.88675H15.5314C16.0709 4.88675 16.5084 5.32417 16.5084 5.86375V9.0375C16.5084 9.57708 16.0709 10.0145 15.5314 10.0145H12.3576C11.818 10.0145 11.3806 9.57708 11.3806 9.0375V5.86375Z"
      fill="#FCC475"
    />
    <path
      d="M8.08447 1.102C8.08447 0.562417 8.52189 0.125 9.06147 0.125H12.968C13.5076 0.125 13.945 0.562418 13.945 1.102V2.811C13.945 3.35058 13.5076 3.788 12.968 3.788H9.06147C8.52189 3.788 8.08447 3.35058 8.08447 2.811V1.102Z"
      fill="#FCC475"
    />
    <path
      d="M17.2411 11.1133H4.42512C4.22298 11.1133 4.05912 10.9494 4.05912 10.7473C4.05912 3.09726 4.05912 2.36601 4.05912 2.30976C4.05763 2.29555 4.05763 2.28122 4.05912 2.26701V2.26176C4.05872 1.98593 3.94872 1.72158 3.75333 1.52689C3.55794 1.33221 3.29319 1.22316 3.01737 1.22376H0.759117C0.354431 1.22376 0.0263672 1.55182 0.0263672 1.95651C0.0263672 2.36119 0.354431 2.68926 0.759117 2.68926H2.22387C2.321 2.68906 2.41421 2.72755 2.48289 2.79624C2.55157 2.86492 2.59007 2.95813 2.58987 3.05526V11.1133C2.58987 11.9226 3.24599 12.5788 4.05537 12.5788H17.2411C17.6458 12.5788 17.9739 12.2507 17.9739 11.846C17.9739 11.4413 17.6458 11.1133 17.2411 11.1133Z"
      fill="#FCC475"
    />
  </svg>
);

export default styled(CartPackagesIcon)``;
